module.exports = __webpack_public_path__ + "static/media/history.d08abf98.svg";